import ScrollToTop from "components/utils/ScrollToTop";
import TitlesUtil from "components/utils/TitlesUtil";
import SnackbarProvider from "providers/SnackbarProvider";
import { Outlet } from "react-router";
import Footer from "./Footer";
import Header from "./Header/Header";
import type { ReactNode } from "react";

function UnauthenticatedRoot(): ReactNode {
  return (
    <SnackbarProvider>
      <Header isAuthenticated={false} />
      <Outlet />
      <Footer />
      <ScrollToTop />
      <TitlesUtil />
    </SnackbarProvider>
  );
}

export default UnauthenticatedRoot;
